import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ZipCodePopup from "@/components/ZipCodePopup";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import PackagesPage from "@/pages/PackagesPage";
import ProductPage from "@/pages/ProductPage";
import PackageDetailPage from "@/pages/PackageDetailPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import OrderTrackingPage from "@/pages/OrderTrackingPage";
import LoginPage, { AccountPage } from "@/pages/LoginPage";
import BuildYourOwnPackagePage from "@/pages/BuildYourOwnPackagePage";
import GiftCardsPage from "@/pages/GiftCardsPage";
import GiftCardSuccessPage from "@/pages/GiftCardSuccessPage";
import WishlistPage from "@/pages/WishlistPage";
import CorporatePage from "@/pages/CorporatePage";
import ReferralsPage from "@/pages/ReferralsPage";
import ArreBoxPage from "@/pages/ArreBoxPage";
import ArreBoxSuccessPage from "@/pages/ArreBoxSuccessPage";
import ParrilladasPage from "@/pages/ParrilladasPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminGiftCards from "@/pages/admin/AdminGiftCards";
import AdminCorporateLeads from "@/pages/admin/AdminCorporateLeads";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminParrilladas from "@/pages/admin/AdminParrilladas";
import AdminBlog from "@/pages/admin/AdminBlog";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navigation />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/paquetes" element={<PackagesPage />} />
          <Route path="/paquete/:slug" element={<PackageDetailPage />} />
          <Route path="/catalogo" element={<CatalogPage />} />
          <Route path="/catalogo/:category" element={<CatalogPage />} />
          <Route path="/producto/:slug" element={<ProductPage />} />
          <Route path="/arma-tu-paquete" element={<BuildYourOwnPackagePage />} />
          <Route path="/regalo" element={<GiftCardsPage />} />
          <Route path="/gift-cards/success" element={<GiftCardSuccessPage />} />
          <Route path="/favoritos" element={<WishlistPage />} />
          <Route path="/empresas" element={<CorporatePage />} />
          <Route path="/referidos" element={<ReferralsPage />} />
          <Route path="/arre-box" element={<ArreBoxPage />} />
          <Route path="/arre-box/success" element={<ArreBoxSuccessPage />} />
          <Route path="/parrilladas" element={<ParrilladasPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/carrito" element={<CheckoutPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/rastreo" element={<OrderTrackingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cuenta" element={<AccountPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="pedidos" element={<AdminOrders />} />
            <Route path="productos" element={<AdminProducts />} />
            <Route path="paquetes" element={<AdminPackages />} />
            <Route path="cupones" element={<AdminCoupons />} />
            <Route path="tarjetas" element={<AdminGiftCards />} />
            <Route path="corporativo" element={<AdminCorporateLeads />} />
            <Route path="suscripciones" element={<AdminSubscriptions />} />
            <Route path="referidos" element={<AdminReferrals />} />
            <Route path="parrilladas" element={<AdminParrilladas />} />
            <Route path="blog" element={<AdminBlog />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ZipCodePopup />}
      {!isAdmin && <CartDrawer />}
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppShell />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
